module.exports = __webpack_public_path__ + "img/area pengunjung.28ebce9b.jpg";